import React from 'react';
import { CreditCard, DollarSign, ScrollText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const EmptyState = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center py-12 px-4">
            <div className="relative mb-6">
                {/* Background circle decoration */}
                <div className="absolute -inset-1 rounded-full bg-muted opacity-30" />
                {/* Layered icons creating a small composition */}
                <div className="relative flex items-center justify-center">
                    <ScrollText className="w-10 h-10 text-gray-500" />
                </div>
            </div>
            <h3 className="text-lg font-semibold mb-2">No Purchase History</h3>
            <p className="text-muted-foreground text-center mb-6 max-w-sm">
                You haven't made any purchases yet. Buy credits to start analyzing websites like never before.
            </p>
            <Button
                onClick={() => navigate('/buy-credits')}
                className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700"
            >
                <CreditCard className="w-4 h-4" />
                Purchase Credits
            </Button>
        </div>
    );
};

export default EmptyState;